// When a visit ends without a reload (B-411): the page away for half an hour
// and back — an installed app resumed from the background, a tab left open
// over a weekend. What a visit keeps (the catch-up shown, and marked) goes,
// so the next look at the League page reads again.
//
// THE SHELL'S, because it is the device's own clock measuring how long the
// page was away; the data layer never reads the machine's time (ICD-S05).

import { endCatchUpVisit } from '../data/catchUp';

/** Away this long and back is a new visit. */
export const AWAY_MS = 30 * 60_000;

let hiddenAt: number | null = null;

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      return;
    }
    if (hiddenAt !== null && Date.now() - hiddenAt >= AWAY_MS) endCatchUpVisit();
    hiddenAt = null;
  });
}
